import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Image, Modal } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

import PromptButton, { BUTTON_TYPES } from 'components/base/prompt/BaseButtons';

import { debounce } from 'utils';
import { getRemarkCreationDateFormatted } from 'utils/TimeFormatUtil';

import CloseIcon from 'assets/images/prompt_close_icon.svg';

import './ExpiryPointListModal.scss';

const mapPropsToState = (state) => ({
  activePoints: state.customerList.activePoints,
  activePointsPage: state.customerList.activePointsPage,
  activePointsHasNextPage: state.customerList.activePointsHasNextPage,
  activePointsIsLoading: state.customerList.activePointsIsLoading,
});

const ExpiryPointListModal = ({
  activePoints,
  activePointsPage,
  activePointsHasNextPage,
  activePointsIsLoading,
  show,
  setShow,
}) => {
  const dispatch = useDispatch();
  const params = useParams();
  const [scrollEvent, setScrollEvent] = useState(null);
  const listInnerRef = useRef();
  const customerId = params.id;

  const onClose = () => {
    setShow(false);
  };

  const refreshList = () => {
    dispatch({
      type: 'customerList/refreshCustomerActivePointList',
      payload: {
        customerId,
      },
    });
  };

  const loadMoreList = debounce(() => {
    console.log('kevin@52');
    dispatch({
      type: 'customerList/loadMoreCustomerActivePointList',
      payload: {
        customerId,
      },
    });
  }, 500);

  const onScroll = useCallback(() => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      const isNearBottom = scrollTop + clientHeight >= scrollHeight;

      if (isNearBottom) {
        console.log('kevin Reached bottom');
        console.log('kevin@49', activePointsHasNextPage, activePointsIsLoading);
        if (activePointsHasNextPage && !activePointsIsLoading) {
          console.log('kevin@50');
          loadMoreList();
        }
      }
    }
  }, [activePointsHasNextPage, activePointsIsLoading]);

  useEffect(() => {
    const listInnerElement = listInnerRef.current;
    if (listInnerElement) {
      listInnerElement.addEventListener('scroll', onScroll);
      return () => {
        listInnerElement.removeEventListener('scroll', onScroll);
      };
    }
  }, [listInnerRef.current]);

  useEffect(() => {
    if (show) {
      refreshList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Body className={`base-prompt-container customer-detail-prompt`}>
        <Image
          src={CloseIcon}
          className="base-prompt-close-button customer-detail-prompt-close-button"
          onClick={onClose}
        />

        <label className="customer-detail-modal-title">Point expiry date</label>

        <div className="customer-detail-scroll-list" ref={listInnerRef}>
          <table className="expiry-point-list">
            <tr>
              <th>Point</th>
              <th>Expiry Date</th>
            </tr>
            {activePoints?.map((item) => {
              return (
                <tr>
                  <td>{item.points}</td>
                  <td>{getRemarkCreationDateFormatted(item.expiry)}</td>
                </tr>
              );
            })}
            {activePointsIsLoading ? (
              <tr>
                <td>Loading...</td>
                <td>&nbsp;</td>
              </tr>
            ) : null}
          </table>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default connect(mapPropsToState)(ExpiryPointListModal);
